import { IVaccinationFormReducer, IVaccinationForm } from 'models/VaccinationForm'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetVaccinationForms,
  VaccinationFormsFetching,
  UpdateVaccinationForm,
  DeleteVaccinationForm,
} from './actions'

const initialState: IVaccinationFormReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const vaccinationFormsReducer = (
  state = initialState,
  action: Action
): IVaccinationFormReducer => {
  if (isType(action, GetVaccinationForms)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateVaccinationForm)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IVaccinationForm>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteVaccinationForm)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IVaccinationForm>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, VaccinationFormsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
